var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { CollapseEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class InformationBarAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onCollapse = new CollapseEventListener();
    }
    /**
     * Returns a boolean indicating if the information bar is collapsed.
     */
    isCollapsed() {
        return this.state.collapsed;
    }
    /**
     * Sets if the information bar should be collapsed.
     *
     * @param colapsed - If the information bar should be collapsed.
     */
    setCollapsed(colapsed) {
        this.setState({ colapsed });
    }
    /**
     * Returns the alerts defined in the information bar.
     */
    getAlerts() {
        return this.state.alerts;
    }
    /**
     * Sets the alerts to be shown in the information bar.
     *
     * @param alerts - the alerts to be shown in the information bar.
     */
    setAlerts(alerts) {
        this.setState({ alerts });
    }
    /**
     * Returns the title of the alerts section in the information bar.
     */
    getAlertsTitle() {
        return this.state.alertsTitle;
    }
    /**
     * Sets the title of the alerts section of the information bar.
     *
     * @param alertsTitle - the title of the alerts section of the information bar.
     */
    setAlertsTitle(alertsTitle) {
        this.setState({ alertsTitle });
    }
    /**
     * Returns the items of the highlighted section of the information bar.
     */
    getHighlighted() {
        return this.state.highlightedList;
    }
    /**
     * Sets the items of the highlighted section of the information bar.
     *
     * @param highlightedList - the items of the highlighted section of the information bar.
     */
    setHighlighted(highlightedList) {
        this.setState({ highlightedList });
    }
    /**
     * Returns the items of the extra information section of the information bar.
     */
    getExtraInformation() {
        return this.state.extraInformation;
    }
    /**
     * Sets the items of the extra information section of the information bar.
     *
     * @param extraInformation - the items of the extra information section of the information bar.
     */
    setExtraInformation(extraInformation) {
        this.setState({ extraInformation });
    }
    /**
     * Returns the title of the extra information section of the information bar.
     */
    getExtraInformationTitle() {
        return this.state.extraInformationTitle;
    }
    /**
     * Sets the title of the extra information section of the information bar.
     *
     * @param extraInformationTitle - the title of the extra information section of the information bar.
     */
    setExtraInformationTitle(extraInformationTitle) {
        this.setState({ extraInformationTitle });
    }
    /**
     * Returns the title of the first field shown in the header of the information bar.
     */
    getFieldOneTitle() {
        return this.state.fieldOneTitle;
    }
    /**
     * Sets the title of the first field shown in the header of the information bar.
     *
     * @param fieldOneTitle - the title of the first field shown in the header of the information bar.
     */
    setFieldOneTitle(fieldOneTitle) {
        this.setState({ fieldOneTitle });
    }
    /**
     * Returns the value of the first field shown in the header of the information bar.
     */
    getFieldOneValue() {
        return this.state.fieldOneValue;
    }
    /**
     * Sets the value of the first field shown in the header of the information bar.
     *
     * @param fieldOneValue - the value of the first field shown in the header of the information bar.
     */
    setFieldOneValue(fieldOneValue) {
        this.setState({ fieldOneValue });
    }
    /**
     * Returns a boolean indicating if the first field is highlighted.
     */
    isFieldOneHighlighted() {
        return Boolean(this.state.highlightFieldOne);
    }
    /**
     * Sets if the first field should be highlighted.
     *
     * @param highlightFieldOne - If the first field should be highlighted.
     */
    setFieldOneHighlight(highlightFieldOne) {
        this.setState({ highlightFieldOne });
    }
    /**
     * Returns the title of the second field shown in the header of the information bar.
     */
    getFieldTwoTitle() {
        return this.state.fieldTwoTitle;
    }
    /**
     * Sets the title of the second field shown in the header of the information bar.
     *
     * @param fieldTwoTitle - the title of the second field shown in the header of the information bar.
     */
    setFieldTwoTitle(fieldTwoTitle) {
        this.setState({ fieldTwoTitle });
    }
    /**
     * Returns the value of the second field shown in the header of the information bar.
     */
    getFieldTwoValue() {
        return this.state.fieldTwoValue;
    }
    /**
     * Sets the value of the second field shown in the header of the information bar.
     *
     * @param fieldTwoValue - the value of the second field shown in the header of the information bar.
     */
    setFieldTwoValue(fieldTwoValue) {
        this.setState({ fieldTwoValue });
    }
    /**
     * Returns a boolean indicating if the second field is highlighted.
     */
    isFieldTwoHighlighted() {
        return Boolean(this.state.highlightFieldTwo);
    }
    /**
     * Sets if the second field should be highlighted.
     *
     * @param highlightFieldTwo - If the second field should be highlighted.
     */
    setFieldTwoHighlight(highlightFieldTwo) {
        this.setState({ highlightFieldTwo });
    }
    /**
     * Returns the source of the image shown in the header of the information bar.
     */
    getImage() {
        return this.state.image;
    }
    /**
     * Sets the image shown in the header of the information bar.
     *
     * @param image - the image shown in the header of the information bar.
     */
    setImage(image) {
        this.setState({ image });
    }
    /**
     * Returns a boolean indicating if the information bar should stick to the top.
     */
    getStickToTop() {
        return this.state.stickToTop;
    }
    /**
     * Sets if the information bar should stick to the top.
     *
     * @param stickToTop - if the information bar should stick to the top.
     */
    setStickToTop(stickToTop) {
        this.setState({ stickToTop });
    }
    /**
     * Returns the title of the information bar.
     */
    getTitle() {
        return this.state.title;
    }
    /**
     * Sets the title of the information bar.
     *
     * @param title - the title of the information bar.
     */
    setTitle(title) {
        this.setState({ title });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], InformationBarAPI.prototype, "onCollapse", void 0);
export default InformationBarAPI;
//# sourceMappingURL=information-bar-api.js.map